//Reset data
export const RESET = "CARACTERISATION_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "CARACTERISATION_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CARACTERISATION_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CARACTERISATION_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CARACTERISATION_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "CARACTERISATION_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CARACTERISATION_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CARACTERISATION_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CARACTERISATION_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CARACTERISATION_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CARACTERISATION_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "CARACTERISATION_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CARACTERISATION_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CARACTERISATION_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CARACTERISATION_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "CARACTERISATION_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "CARACTERISATION_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CARACTERISATION_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CARACTERISATION_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CARACTERISATION_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "CARACTERISATION_DEL_SET_IS_UPDATE"